// pipe: driver UI polish — a short tactile confirmation when the driver commits a
// pickup. Uses the Web Vibration API, which works inside the Android WebView when
// the app holds the VIBRATE permission (declared in the shell manifest); it is a
// silent no-op everywhere it is unsupported or blocked (desktop web, or a device
// with no vibrator). Intentionally dependency-free — no @capacitor/haptics plugin /
// native module to register — so it needs no cap-sync wiring.
export function tapHaptic(): void {
  try {
    navigator.vibrate?.(12);
  } catch {
    /* vibration unsupported / blocked — ignore (non-blocking polish) */
  }
}
